import { UserRole } from "Infrastructure/Api/Api";
import { useRole } from "Infrastructure/Hooks/useRole";
import type { ReactNode } from "react";

type RoleSwitchedViewProps = {
  gameMasterView: ReactNode;
  userView: ReactNode;
  fallback?: ReactNode;
};

export const RoleSwitchedView = ({
  gameMasterView,
  userView,
  fallback = null,
}: RoleSwitchedViewProps) => {
  const { role } = useRole();

  switch (role) {
    case UserRole.GameMaster:
      return <>{gameMasterView}</>;
    case UserRole.User:
      return <>{userView}</>;
    default:
      return <>{fallback}</>;
  }
};
